import { APP_CONSTANTS } from "../../constants";
import { api } from "../api";

const userApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query<[], { page: number, search?: string }>({
      query: ({ page = 1, search }) => {
        const take = APP_CONSTANTS.TABLES.users.limit;
        const skip = (page - 1) * take;

        let queryString = `/user?skip=${skip}&take=${take}`;

        if (search) queryString += `&search=${search}`;

        // Gender filter: male or female
        const genderFilter = '{"gender":{"in":["male","female"]}}';
        queryString += `&where=${encodeURIComponent(genderFilter)}`;

        const includeFilter =
          '&include={"doctor":{"include":{"speciality":true}}}';
        queryString += includeFilter;

        return queryString;
      },
    }),
  }),
});

export const {
  useGetUsersQuery,
} = userApi;

export default userApi;
